<template>
    <div class="flex items-center">
        <div class="bg-a-brown-502314 rounded-full flex text-13 border border-a-brown-502314 p-1px cursor-pointer" @click="clickSwitchLang()">
            <div class="rounded-full px-2 py-2px unselectable" :class="[getClassActiveBtn(1054)]">{{lbl.profile.th}}</div>
            <div class="rounded-full px-2 py-2px unselectable" :class="[getClassActiveBtn(1033)]">{{lbl.profile.en}}</div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin'

export default {
    mixins: [LocaleMixin],

    methods: {
        getClassActiveBtn: function (btnCode) {
            if (this.localeCode == btnCode) {
                return 'bg-a-egg-f5ebdc text-a-brown-502314';
            }
            return 'bg-a-brown-502314 text-a-egg-f5ebdc';
        },

        clickSwitchLang: function () {
            let changeLocale = this.localeCode == 1033 ? 1054 : 1033;
            let localeFormat = changeLocale == 1033 ? 'english' : 'thai';
            this.tracking.event('moremenu','click_change_language', `change_language_to_${localeFormat}`);

            this.switchLang(changeLocale);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    .topbar-height {
        height: $topbar-height;
    }
</style>
